export default {
	add_to_your_calendar: "Ajouter à votre calendrier",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explorez tout notre ensemble de cours, vidéos, articles et fichiers exclusifs.",
	no_events_available_for_the_selected_date: "Aucun évènement n’est disponible.",
	welcome_to: "Bienvenue à",
	what_do_you_want_to_learn_today: "Que voulez-vous étudier aujourd’hui ?"
}